module.exports = __webpack_public_path__ + "static/media/thunder-cloud-rain.b5a8df4a.png";